export default __webpack_public_path__ + "static/media/ZZC_7845.6eb15e71.jpg";